import styled from 'styled-components';
import { Link } from 'edenred-ui';

export const StyledLink = styled(Link)`
  color: ${props => props.theme.secondaryFrontColor};
  &:hover {
    color: ${props => props.theme.secondaryFrontColor};
  }
  &:visited {
    color: ${props => props.theme.secondaryFrontColor};
  }
`;
